export default __webpack_public_path__ + "static/media/flex.03a9b9d7.pdf";